import {
  Box,
  Grid,
  IconButton,
  ListItem,
  SwipeableDrawer,
  Tooltip,
  Typography,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import React, { useContext, useEffect, useState } from 'react';
import {
  activeTheme,
  getActiveTheme,
  THEME_NAMES,
} from '../../Utils/Themes/themeHelper';
import { makeStyles, withStyles } from '@mui/styles';
import ApplicationsNav from '../../Assets/Svg/applications.svg';
import { AuthContext } from '../../Context/authContext';
import ExitToAppOutlinedIcon from '@mui/icons-material/ExitToAppOutlined';
import FacebookIcon from '../../Assets/SvgImages/FacebookIcon.svg';
import HomeNav from '../../Assets/Svg/home.svg';
import JDFullLogo from '../../Assets/sidebar/jd-full-logo.png';
import JDHalfLogo from '../../Assets/sidebar/jd-half-logo.png';
import KeyboardDoubleArrowLeftIcon from '@mui/icons-material/KeyboardDoubleArrowLeft';
import KeyboardDoubleArrowRightIcon from '@mui/icons-material/KeyboardDoubleArrowRight';
import LinkedinIcon from '../../Assets/SvgImages/LinkedinIcon.svg';
import List from '@mui/material/List';
import ManipalFullLogo from '../../Assets/sidebar/manipal-full-logo.svg';
import ManipalHalfLogo from '../../Assets/sidebar/manipal-half-logo.png';
import StpiLogo from '../../Assets/Images/client/stpi-logo.png';
import NSOMFullLogo from '../../Assets/sidebar/nsom-full-logo.png';
import NSOMHalfLogo from '../../Assets/sidebar/nsom-half-logo.png';
import STPIHalfLogo from '../../Assets/sidebar/stpi-logo.png';
// import tieLogo from '../../Assets/sidebar/tieLogo.png';
import MuiDrawer from '@mui/material/Drawer';
import { NavLink } from 'react-router-dom';
import { TABLET_BREAKPOINT } from '../../Constants/constant';
import WorkOutlineIcon from '@mui/icons-material/WorkOutline';
import TwitterIcon from '../../Assets/SvgImages/TwitterIcon.svg';
import clsx from 'clsx';
import routes from '../../Constants/routes';
import styled from '@emotion/styled';

const drawerWidth = 210;
const tieLogo = "https://inazstgpfs3001.blob.core.windows.net/assets/venturisesidenavlogo.png";
const tieLogo2 = "https://inazstgpfs3001.blob.core.windows.net/assets/Images/TIE/TiEFavicon.jpg";

const getSidebarLogo = (open) => {
  return {
    JDIFT: open ? JDFullLogo : JDHalfLogo,
    MANIPAL: open ? ManipalFullLogo : ManipalHalfLogo,
    NSOM: open ? NSOMFullLogo : NSOMHalfLogo,
    KEN42: open ? JDFullLogo : JDHalfLogo,
    VENTURISE: open ? tieLogo : tieLogo2,
    STPI: open ? StpiLogo : STPIHalfLogo
  }[getActiveTheme()];
};

const imageMap = {
  fb: FacebookIcon,
  twitter: TwitterIcon,
  linkedIn: LinkedinIcon,
};

const getSocialLinks = () => {
  let socialLinks = [];
  switch (getActiveTheme()) {
    case THEME_NAMES.JDIFT:
      socialLinks = [
        {
          title: 'Facebook',
          link: '#',
          img: 'fb',
        },
        {
          title: 'Twitter',
          link: '#',
          img: 'twitter',
        },
        {
          title: 'LinkedIn',
          link: '#',
          img: 'linkedIn',
        },
      ];
      break;
    case THEME_NAMES.MANIPAL:
      socialLinks = [
        {
          title: 'Facebook',
          link: 'https://www.facebook.com/mahemanipal/',
          img: 'fb',
        },
        {
          title: 'Twitter',
          link: 'https://twitter.com/MAHE_Manipal',
          img: 'twitter',
        },
        {
          title: 'LinkedIn',
          link: 'https://www.linkedin.com/school/manipalacademyofhighereducation/',
          img: 'linkedIn',
        },
      ];
      break;
    case THEME_NAMES.NSOM:
      socialLinks = [
        {
          title: 'Facebook',
          link: 'https://www.facebook.com/NSMBangalore/',
          img: 'fb',
        },
        {
          title: 'Twitter',
          link: 'https://twitter.com/NSOM_BLORE?s=20&t=lB5iiisoQsO8eJmuQ4yxVQ',
          img: 'twitter',
        },
        {
          title: 'LinkedIn',
          link: 'https://www.linkedin.com/school/nitte-school-of-management/about/',
          img: 'linkedIn',
        },
      ];
      break;
    case THEME_NAMES.KEN42:
      socialLinks = [
        {
          title: 'Facebook',
          link: '#',
          img: 'fb',
        },
        {
          title: 'Twitter',
          link: '#',
          img: 'twitter',
        },
        {
          title: 'LinkedIn',
          link: '#',
          img: 'linkedIn',
        },
      ];
      break;
    case THEME_NAMES.VENTURISE:
      socialLinks = [
        {
          title: 'Facebook',
          link: 'https://www.facebook.com/tie.chapterbangalore',
          img: 'fb',
        },
        {
          title: 'Twitter',
          link: 'https://twitter.com/TiEBangalore?s=20&t=9Ha6U0Jgf_Y_HKOLAd-A8Q',
          img: 'twitter',
        },
        {
          title: 'LinkedIn',
          link: 'https://www.linkedin.com/company/tie-bangalore',
          img: 'linkedIn',
        },
      ];
      break;
    default:
      socialLinks = [
        {
          title: 'Facebook',
          link: '#',
          img: 'fb',
        },
        {
          title: 'Twitter',
          link: '#',
          img: 'twitter',
        },
        {
          title: 'LinkedIn',
          link: '#',
          img: 'linkedIn',
        },
      ];
  }
  return socialLinks;
};

const useStyles = makeStyles((theme) => ({
  listItem: {
    padding: '12px 20px',
    width: 'calc(100% + 20px)',
    marginBottom: 8,
    '&:hover': {
      width: 'calc(100% + 20px)',
      backgroundColor: theme.palette.KenColors.sideNavItemHoverBackground,
      borderRadius: '24px 0px 0px 24px',

      '& $subLevel': {
        color: theme.palette.KenColors.sideNavItemHoverColor,
      },
      '& $heading': {
        color: theme.palette.KenColors.sideNavItemHoverColor,
      },
    },
    '&.Mui-selected': {
      backgroundColor: 'turquoise',
      color: 'white',
      fontWeight: 600,
      borderRadius: '24px 0px 0px 24px',
    },
    borderRadius: '24px 0px 0px 24px',
  },
  active: {
    '& $listItem': {
      width: 'calc(100% + 20px)',
      // backgroundColor: '#CF222F',
      backgroundColor: '#28AAE1',
      borderRadius: '24px 0px 0px 24px',
    },

    '& $subListItem': {
      borderLeft: `4px solid ${theme.palette.KenColors.kenWhite}`,
      marginLeft: 0,
      backgroundColor: '#CF222F',
      borderRadius: '24px 0px 0px 24px',
    },

    '& $heading': {
      color: theme.palette.KenColors.sideNavItemActiveColor,
    },
    '& $subLevel': {
      color: theme.palette.KenColors.sideNavItemActiveColor,
    },
    '&.Mui-selected': {
      backgroundColor: theme.palette.KenColors.sideNavItemActiveBackground,
      color: 'white',
      fontWeight: 600,
      borderRadius: '24px 0px 0px 24px',

      '&:hover': {
        backgroundColor: theme.palette.KenColors.sideNavItemActiveBackground,
        // color: 'white',
        borderRadius: '24px 0px 0px 24px',
      },
    },
    textDecoration: 'none',
    borderRadius: '24px 0px 0px 24px',
  },
  menuIcon: {
    color: theme.palette.KenColors.kenWhite,

    '& >p': {
      display: 'flex',
      color: theme.palette.KenColors.kenWhite,
    },
  },
  heading: {
    fontStyle: 'normal',
    fontWeight: 'normal',
    fontSize: '0.875rem',
    lineHeight: '20px',
    display: 'flex',
    alignItems: 'center',
    color: theme.palette.KenColors.kenWhite,
  },
  drawer: {
    justifyContent: 'space-between',
    width: drawerWidth,
    flexShrink: 0,
    whiteSpace: 'nowrap',
    background: activeTheme.drawer.background,
    borderRadius: 12,
    borderTopLeftRadius: 0,
    borderBottomLeftRadius: 0,
    height: '100vh',
    [theme.breakpoints.down('md')]: {
      margin: 0,
      borderRadius: '0px 24px 24px 0px',
      height: '100vh',
      'overflow-x': 'hidden',
    },
  },
  root: {
    [theme.breakpoints.down(TABLET_BREAKPOINT)]: {
      // Note: added so side bar drawer show on top of header when active
      'z-index': '1302',
    },
  },
  icon: {
    color: theme.palette.KenColors.kenWhite,
  },
  link: {
    textDecoration: 'none',
  },
  typoReserved: {
    fontSize: 10,
    color: theme.palette.KenColors.kenWhite,
  },
  typoReservedOpen: {
    width: 88,
    whiteSpace: 'initial',
  },
  imageBanner: {
    width: 35,
    height: 35,
  },
  imageBannerPositionFix: {
    position: 'relative',
    left: '-10px',
    top: '-2px',
  },
  imageBannerDetailed: {
    width: 154,
    height: 40,
    marginRight: 8,
  },
  logoBackground: {
    background: 'white',
    'border-radius': '16px',
    'border-top-left-radius': '0',
    'border-bottom-left-radius': '0',
    position: 'relative',
    left: '-10px',
    'max-height': '55px',
    minHeight: '55px',
    display: 'flex',
    'justify-content': 'center',
    'align-items': 'center',
    'padding-left': '10px',
    minWidth: 76,
  },
}));

const DrawerHeader = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-end',
  padding: theme.spacing(0, 1),
  // necessary for content to be below app bar
  ...theme.mixins.toolbar,
}));

const DrawerFooter = styled('div', {
  shouldForwardProp: (prop) => prop !== 'open',
})(({ theme }) => ({
  opacity: 1,
  marginBottom: theme.spacing(3),
  ...theme.mixins.toolbar,
}));

const Drawer = styled(MuiDrawer, {
  shouldForwardProp: (prop) => prop !== 'open',
})(({ theme, open }) => ({
  width: drawerWidth,
  flexShrink: 0,
  whiteSpace: 'nowrap',
  boxSizing: 'border-box',
  ...(open && {
    ...openedMixin(theme),
    '& .MuiDrawer-paper': openedMixin(theme),
  }),
  ...(!open && {
    ...closedMixin(theme),
    '& .MuiDrawer-paper': closedMixin(theme),
  }),
}));

const openedMixin = (theme) => ({
  width: drawerWidth,
  transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  overflowX: 'hidden',
  display: 'relative',
});

const closedMixin = (theme) => ({
  transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  overflowX: 'hidden',
  width: `calc(${theme.spacing(8)} + 1px)`,
  [theme.breakpoints.up('sm')]: {
    width: `calc(${theme.spacing(12)} + 1px)`,
  },
});

const LightTooltip = withStyles((theme) => ({
  tooltip: {
    backgroundColor: theme.palette.common.white,
    color: 'rgba(0, 0, 0, 0.87)',
    boxShadow: theme.shadows[1],
    fontSize: 14,
  },
}))(Tooltip);

const menu = [
  {
    icon: <img src={HomeNav} alt="" />,
    label: 'Home',
    // link: routes.home,
    link: routes.evaluation,
    callback: '',
  },
  // {
  //   icon: <img src={ApplicationsNav} alt="" />,
  //   label: 'Events',
  //   link: routes.events,
  //   callback: '',
  // },
  // {
  //   icon: <Grid item xs={8}>
  //     <WorkOutlineIcon />
  //   </Grid>,
  //   label: 'Jobs',
  //   link: routes.jobs,
  //   callback: '',
  // },
  // {
  //   icon: <Grid item xs={8}>
  //     <WorkOutlineIcon />
  //   </Grid>,
  //   label: 'Evaluation',
  //   link: routes.evaluation,
  //   callback: '',
  // },
];

const GetSideNavData = (data) => {
  const classes = useStyles();
  const { open, handleDrawerClose, handleDrawerOpen, sideNavMenu } = data;
  const theme = useTheme();

  return (
    <>
      <Box>
        <DrawerHeader>
          <Grid container direction="column">
            <Grid
              item
              style={{ textAlign: 'left', marginTop: 16, minHeight: 92 }}
              display="flex"
              justifyContent="flex-start"
              alignItems="center"
            >
              <Box className={classes.logoBackground}>
                <img
                  src={getSidebarLogo(open)}
                  alt="Ken42 Icon"
                  className={clsx(classes.imageBanner, {
                    [classes.imageBannerDetailed]: open === true,
                    [classes.imageBannerPositionFix]: !open,
                  })}
                />
              </Box>
            </Grid>
            <Grid
              item
              style={{ textAlign: 'right', marginRight: -12, paddingTop: 16 }}
              sx={{ display: { xs: 'none', tablet: 'block' } }}
            >
              <IconButton
                style={{ padding: 12 }}
                onClick={open ? handleDrawerClose : handleDrawerOpen}
              >
                {!open ? (
                  <KeyboardDoubleArrowRightIcon className={classes.icon} />
                ) : (
                  <KeyboardDoubleArrowLeftIcon className={classes.icon} />
                )}
              </IconButton>
            </Grid>
          </Grid>
        </DrawerHeader>
        <List
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            paddingLeft: open ? '40px' : undefined,
          }}
        >
          {sideNavMenu &&
            sideNavMenu?.map((item, index) => {
              return (
                <NavLink
                  key={index}
                  to={item?.link}
                  className={({ isActive }) =>
                    isActive ? classes.active : classes.link
                  }
                >
                  <ListItem
                    onClick={item.callback}
                    classes={{
                      root: classes.listItem,
                      selected: classes.active,
                    }}
                    button
                  >
                    <Grid
                      container
                      alignItems="center"
                      sx={{ minWidth: open ? 180 : undefined }}
                    >
                      <Grid item sx={{ minWidth: open ? '32px' : undefined }}>
                        {open === false ? (
                          <LightTooltip
                            title={item.label}
                            placement="right-end"
                          >
                            <span className={classes.menuIcon}>
                              <Typography>{item.icon}</Typography>
                            </span>
                          </LightTooltip>
                        ) : (
                          <span className={classes.menuIcon}>
                            <Typography>{item.icon}</Typography>
                          </span>
                        )}
                      </Grid>
                      <Grid item>
                        {open && (
                          <span className={classes.heading}>{item.label}</span>
                        )}
                      </Grid>
                    </Grid>
                  </ListItem>
                </NavLink>
              );
            })}
        </List>
      </Box>
      <DrawerFooter open={open}>
        <Grid
          container
          alignItems="center"
          justifyContent="center"
          direction="column"
        >
          <Grid marginBottom={theme.spacing(2)}>
            <>
              <Grid
                container
                spacing={open ? 2 : 1}
                direction={open ? 'row' : 'column'}
              >
                {getSocialLinks().map((i, index) => {
                  return (
                    <Grid key={index} item display="flex" alignItems="flex-end">
                      <a href={i.link} target="_blank">
                        <img src={imageMap[i.img]} alt="linkedin" />
                      </a>
                    </Grid>
                  );
                })}
              </Grid>
            </>
          </Grid>
          <Grid item>
            <Typography
              className={clsx(classes.typoReserved, {
                [classes.typoReservedOpen]: open === false,
              })}
              style={{ marginBottom: '10px' }}
            >
              Powered By <img src="https://inazstgpfs3001.blob.core.windows.net/assets/Turbostartlogo.png" alt="txt" height="20px" width="60px" />
            </Typography>
          </Grid>
          <Grid item>
            <Typography
              className={clsx(classes.typoReserved, {
                [classes.typoReservedOpen]: open === false,
              })}
            >
              © 2022 All rights Reserved
            </Typography>
          </Grid>
        </Grid>
      </DrawerFooter>
    </>
  );
};

export default function SideNavigation(props) {
  const [sideNavMenu, setSideNavMenu] = useState(menu);
  const classes = useStyles();
  const theme = useTheme();
  const isMobileScreen = useMediaQuery(
    theme.breakpoints.down(TABLET_BREAKPOINT)
  );
  const smallScreen = useMediaQuery(theme.breakpoints.down('sm'));

  const { dispatch } = useContext(AuthContext);
  const { open, setSwipeableDrawer, swipeableDrawer, setOpen } = props;

  useEffect(() => {
    setSideNavMenu(() => {
      let temp = [
        ...sideNavMenu.map((i) => {
          // Note: added to close drawer on mobile devices
          if (typeof i?.callback !== 'function') {
            i.callback = () => {
              setSwipeableDrawer(false);
            };
          }
          return i;
        }),
      ];

      // Check side menu is not already having logout button
      if (
        smallScreen &&
        (sideNavMenu || []).filter((s) => s.label === 'Logout').length === 0
      ) {
        temp.push({
          icon: <ExitToAppOutlinedIcon />,
          label: 'Logout',
          link: ``,
          callback: () => {
            dispatch({
              type: 'LOGOUT',
              payload: {
                user: {},
                token: null,
              },
            });
          },
        });
      }

      return temp;
    });
  }, [dispatch, isMobileScreen, setSwipeableDrawer, smallScreen]);

  useEffect(() => {
    if (isMobileScreen) {
      setOpen(true);
    } else {
      setOpen(false);
    }
  }, [isMobileScreen, setOpen]);

  const toggleDrawer = () => {
    setSwipeableDrawer(false);
  };

  return (
    <Box style={{ margin: 0 }} sx={{ m: isMobileScreen ? undefined : 2 }}>
      {!isMobileScreen ? (
        <Drawer
          variant="permanent"
          open={open}
          classes={{ paper: classes.drawer, root: classes.root }}
        >
          <GetSideNavData sideNavMenu={sideNavMenu} {...props} />
        </Drawer>
      ) : (
        <SwipeableDrawer
          anchor={'left'}
          open={swipeableDrawer}
          onClose={toggleDrawer}
          classes={{ paper: classes.drawer, root: classes.root }}
        >
          <GetSideNavData sideNavMenu={sideNavMenu} {...props} />
        </SwipeableDrawer>
      )}
    </Box>
  );
}
